<section class="pt-6 pb-7 mt-5" id="features">
    <div class="container">
        <div class="row my-5">
            <div class="col-md-6 mx-auto text-center">
                <h2 class="heading-black">The Covid-19 Tracker</h2>
                <p class="text-muted lead">News and mainstream media are blind folded and biased</p>
                <p class="text-muted lead">Know your Facts Right</p>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-md-6 col-lg-5">
                <h4>Sign up, It's Free</h4>
                <p class="text-muted">The Covid-19 Hub application provides you with precise information
                    that you need to know about the prevailing pandamic. Click the Login/Sign up button to know
                    more
                </p>
            </div>
            <div class="col-md-6 col-lg-5">
                <h4>Informatica, Precisa</h4>
                <p class="text-muted">Get exclusive access to real time information on everything you need to
                    know about the prevailing pandamic</p>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-md-6 col-lg-5">
                <h4>The i-bot persona</h4>
                <p class="text-muted">Chat with our very own i-bot to fetch answers to all your questions about
                    the prevailing pandamic.</p>
            </div>
            <div class="col-md-6 col-lg-5">
                <h4>The COVID-19 Detection Tool</h4>
                <p class="text-muted">Fill up the very few questions we'd like you to ask to know the chances of
                    YOU getting affected by COVID - 19</p>
            </div>
        </div>

        <!-- 
        <br>
        <hr>
        <br>
        <div class="row">
            <div class="col-sm-6">
                <p>COVID-19 affects different people in different ways.
                    Most infected people will develop mild to moderate illness and recover without hospitalization.</p>
                <hr>
                <h3>Most Common symptoms</h3>
                <ul class="list-group">
                    <li class="list-group-item">Fever</li>
                    <li class="list-group-item">Dry Cough</li>
                    <li class="list-group-item">Tiredness</li>
                </ul>
                <h3>Less Common symptoms</h3>
                <ul class="list-group">
                    <li class="list-group-item">Aches and Pains</li>
                    <li class="list-group-item">Sore Throat</li>
                    <li class="list-group-item">Diarrohea</li>
                    <li class="list-group-item">Conjuctives</li>
                    <li class="list-group-item">Headaches</li>
                    <li class="list-group-item">Lack of taste and smell</li>
                    <li class="list-group-item">Rashes</li>
                </ul>
                <h3>Most Common symptoms</h3>
                <ul class="list-group">
                    <li class="list-group-item">Difficulty in breathing</li>
                    <li class="list-group-item">Chest Pain or Pressure</li>
                    <li class="list-group-item">Loss of Speech</li>
                </ul>
                <hr>
                <p>Seek immediate medical attention if you have serious symptoms. Always call before visiting your
                    doctor or health facility.
                    People with mild symptoms who are otherwise healthy should manage their symptoms at home. <br>
                    On average it takes 5–6 days from when someone is infected with the virus for symptoms to show,
                    however it can take up to 14 days.</p>

            </div>

            <div class="col-sm-6">
                <h3>Self Care Methods</h3><br>
                <ul class="list-group">
                    <li class="list-group-item">Call your health care provider or COVID-19 hotline to find out where and
                        when to get a test.</li>
                    <li class="list-group-item">Cooperate with contact-tracing procedures to stop the spread of the
                        virus.</li>
                    <li class="list-group-item">If testing is not available, stay home and away from others for 14 days.
                    </li>
                    <li class="list-group-item">Keep at least a 1-metre distance from others, even from your family
                        members.</li>
                    <li class="list-group-item">Wear a medical mask to protect others, including if/when you need to
                        seek medical care.
                        Clean your hands frequently.</li>
                    <li class="list-group-item">Keep the room well-ventilated.</li>
                    <li class="list-group-item">Stay positive by keeping in touch with loved ones by phone or online,
                        and by exercising at home.</li>
                    <li class="list-group-item">If you share a room, place beds at least 1 metre apart.</li>
                </ul>
                <br>
                <h3>Medical Treatments</h3>
                <ul class="list-group">
                    <li class="list-group-item">Optimal supportive care includes oxygen for severely ill patients and
                        those who are at risk for severe disease and more advanced respiratory support such as
                        ventilation for patients who are critically ill</li>
                    <li class="list-group-item">Dexamethasone is a corticosteroid that can help reduce the length of
                        time on a ventilator and save lives of patients with severe and critical illness.
                    </li>
                </ul>
                <hr>
                <br><br>Learn more at<a
                    href="https://www.who.int/emergencies/diseases/novel-coronavirus-2019/question-and-answers-hub/q-a-detail/coronavirus-disease-covid-19#:~:text=symptoms">
                    who.int
                </a>
            </div>
        </div>
-->
    </div>
    <footer>
        <div class="container-fluid text-center p-3" style="background-color: rgba(0, 0, 0, 0.2); margin-top: 14rem;">
            <p>Seek immediate medical attention if you have serious symptoms. Always call before visiting
                your
                doctor or health facility.
                People with mild symptoms who are otherwise healthy should manage their symptoms at home.
                <br>
                On average it takes 5–6 days from when someone is infected with the virus for symptoms to
                show,
                however it can take up to 14 days.
            </p>
            <p>Learn more at
            <a class="text-dark"
                href="https://www.who.int/emergencies/diseases/novel-coronavirus-2019/question-and-answers-hub/q-a-detail/coronavirus-disease-covid-19#:~:text=symptoms">who.int</a></p>
        </div>
    </footer>
</section>